import {
  ChangeDetectorRef,
  Directive,
  EventEmitter,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewContainerRef
} from '@angular/core';
import { ScreenDetectorService } from '../service/screen-detector.service';
import {Subject, Subscription} from 'rxjs';
import {debounceTime, takeUntil, takeWhile} from "rxjs/operators";
import {ScreenDetectorAnswer} from "../@absract/@interface/IConfig.interface";

/* @example â1 - <div *ifScreenLessThen='700'></div> */
/* @example â2 - <div *ifScreenLessThen='700,300'></div> */

@Directive({ selector: '[ifScreenLessThen]' })
export class IfScreenLessThenDirective implements OnInit, OnDestroy {
  @Input('ifScreenLessThen') public ifScreenLessThen: string;
  @Input('mzDebounceTime') public mzDebounceTime? = 250;
  @Output('mzScreenChange') public mzScreenChange: EventEmitter<ScreenDetectorAnswer> = new EventEmitter<ScreenDetectorAnswer>();


  private nInvokedCounter = 0;

  private w = 0;
  private h = 0;
  // private alive = true;
  private alive$: Subject<void> = new Subject();

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private screenDetector: ScreenDetectorService,
    private cdRef: ChangeDetectorRef,
    private zone: NgZone
  ) {}

  ngOnInit() {
    this.safeSetParams(this.ifScreenLessThen);

    this.screenDetector.getSubscription(
      this.mzDebounceTime,
      this.alive$,
      false
    ).subscribe(screen => {
        this.mzScreenChange.emit(screen);
        this.check(screen.width, screen.height);
        this.cdRef.markForCheck();
      }
    );
  }

  ngOnDestroy() {
    // this.alive = false;
    this.alive$.next();
    this.alive$.unsubscribe();
    // this.subscription.unsubscribe();
  }

  private check(w: number, h: number) {
    this.performCondition((!this.w || this.w > w) && (!this.h || this.h > h));
  }

  /**
   * Ð£ÑÑÐ°Ð½Ð¾Ð²ÐºÐ° Ð¿Ð°ÑÐ°Ð¼ÐµÑÑÐ¾Ð²
   * */
  private safeSetParams(data: string) {
    const params = data.split(',');
    if (params[0]) {
      const w = parseInt(params[0], 10);
      if (!isNaN(w)) this.w = w;
    }

    if (params[1]) {
      const h = parseInt(params[1], 10);
      if (!isNaN(h)) this.h = h;
    }
  }

  private performCondition(condition) {
    if (condition) {
      if (this.nInvokedCounter > 0) this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.nInvokedCounter++;
    } else {
      this.viewContainer.clear();
    }
  }
}
